let module = {};

/**
 * Container Initialization
 */
module.init = function () {
    let tabsWrap = document.querySelectorAll('.js-tabbed-nav');

    tabsWrap.forEach((tabsWrap) => {

        let tabActive = tabsWrap.getAttribute( 'data-tab-active' );
        let tabsLi = tabsWrap.querySelectorAll( '.js-tabbed-nav-item' );
        let tabsBody = tabsWrap.querySelectorAll( '.js-tabbed-nav-body' );

        tabsLi.forEach((tab) => {
            tab.addEventListener( 'click', function ( e ) {
                e.preventDefault();

                clickedTabId = tab.getAttribute('data-tab');

                //check to see if our tab selection changed
                if ( tabActive != clickedTabId){
                    //set our new active tab
                    tabsWrap.dataset.tabActive = clickedTabId;
                    // remove active class from other tabs
                    tabsLi.forEach((tabItem) => {
                        tabItem.parentNode.classList.remove('uagb-tabs__active');
                    });
                    // remove active class from body
                    tabsBody.forEach((tabBody) => {
                        tabBody.classList.remove('uagb-tabs-body__active');
                        if ( tabBody.dataset.tabBody === clickedTabId ){
                            tabBody.classList.add('uagb-tabs-body__active');
                        }
                    });
                    // add active class to tab
                    tab.parentNode.classList.add('uagb-tabs__active');
                    tabActive = clickedTabId;
                }
            } );
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});



